import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "@/providers/ThemeProvider";
import { AuthProvider, ProtectedRoute } from "@/providers/AuthProvider";
import { QueryProvider } from "@/providers/QueryProvider";
import { KBLayout } from "@/components/kb/KBLayout";
import { LoginPage } from "@/pages/LoginPage";
import { KBHomePage } from "@/pages/KBHomePage";
import { KBArticlePage } from "@/pages/KBArticlePage";
import { KBEditPage } from "@/pages/KBEditPage";

// Trigger redeploy with environment variable
function App() {
  return (
    <ThemeProvider defaultTheme="light">
      <QueryProvider>
        <AuthProvider>
          <Router>
            <Routes>
              <Route path="/app/login" element={<LoginPage />} />
              <Route
                path="/app"
                element={
                  <ProtectedRoute>
                    <KBLayout />
                  </ProtectedRoute>
                }
              >
                <Route path="kb" element={<KBHomePage />} />
                <Route path="kb/:slug" element={<KBArticlePage />} />
                <Route
                  path="kb/:slug/edit"
                  element={
                    <ProtectedRoute requireAdmin={true}>
                      <KBEditPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="kb/new"
                  element={
                    <ProtectedRoute requireAdmin={true}>
                      <KBEditPage />
                    </ProtectedRoute>
                  }
                />
                <Route index element={<Navigate to="/app/kb" replace />} />
              </Route>
              <Route path="/" element={<Navigate to="/app/kb" replace />} />
            </Routes>
          </Router>
        </AuthProvider>
      </QueryProvider>
    </ThemeProvider>
  );
}

export default App;